export default __webpack_public_path__ + "static/media/danger.af3f4bef.svg";